import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { environment } from '@environment';
import { ConfigService } from '../config.service';
import { Observable } from 'rxjs';
import { EInterceptorOptionsHTTPHeaders } from 'src/app/_helpers/interceptors/EInterceptorOptionsHTTPHeaders';
import { Utilities } from 'src/app/_helpers/utility/utilities';
import { IReportedStrategy } from 'src/app/_interfaces/strategy/IReportedStrategy';
import { IEstimatedIncidentCostElements, IEstimatedIncidentCostSaveElements } from 'src/app/_interfaces/strategy/IStrategicIncidentCost';
import { WfdssCase } from 'src/app/_models/incident/wfdssCase/wfdssCase';

@Injectable({
  providedIn: 'root'
})
export class CostService {
  private readonly baseUrl = this.environment.caseApi.baseUrl;
  constructor(private httpSvc: HttpClient, private environment: ConfigService) { }
  

  getEstimatedFinalCostForWfdssCase(
    caseId: WfdssCase["wfdssCaseId"]
  ): Observable<IEstimatedIncidentCostSaveElements> {
    return this.httpSvc
      .get<any>(
        `${this.baseUrl}/cases/${caseId}/estimatedFinalCost`,
        {
          headers: Utilities.appendHTTPHeaderForInterceptor([
            EInterceptorOptionsHTTPHeaders.SuppressErrorInterceptor,
          ]),
        }
      );
  }

  putEstimatedFinalCostForWfdssCase(
    caseId: WfdssCase["wfdssCaseId"],
    estimatedFinalCostData: IEstimatedIncidentCostSaveElements
  ) {
    return this.httpSvc.put<IEstimatedIncidentCostSaveElements>(
      `${this.baseUrl}/cases/${caseId}/estimatedFinalCost`,
      estimatedFinalCostData,
      {
        params: {
          timestampOfLastUpdate: 0,
          isForceOverwriteRequested: false,
        },
      }
    );
  }

  saveCostReadyForPublication(caseId: WfdssCase["wfdssCaseId"],
      isReadyForPublication: boolean
    ): Observable<any> {
      const params = new HttpParams().set('isReadyForPublication', isReadyForPublication);
      const url =  `${this.baseUrl}/cases/${caseId}/costReadyForPublication`;
      return this.httpSvc
        .get<any>(url,
          {
            params,
            headers: Utilities.appendHTTPHeaderForInterceptor([
              EInterceptorOptionsHTTPHeaders.SuppressErrorInterceptor,
            ]),
          });
  }     
    
}
